<script setup lang="ts">
import { PERF_DEBUG } from '~/utils/constants'
const { localeMeta } = useAppI18n()
const MOBILE_USER_AGENT_PATTERN = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Windows Phone/i

const getClientUserAgent = () => {
  if (!import.meta.client) {
    return ''
  }

  return window.navigator.userAgent
}

const requestUserAgent = import.meta.server
  ? (useRequestHeaders(['user-agent'])['user-agent'] ?? '')
  : getClientUserAgent()
const isMobileUserAgent = MOBILE_USER_AGENT_PATTERN.test(requestUserAgent)

if (import.meta.client && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}

useHead(() => ({
  htmlAttrs: {
    lang: localeMeta.language,
    dir: localeMeta.dir,
  },
  meta: [
    {
      key: 'viewport',
      name: 'viewport',
      content: isMobileUserAgent ? 'width=1200' : 'width=device-width, initial-scale=0.5',
    },
  ],
}))
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <DevSsrRequestInspector v-if="PERF_DEBUG" />
  </ClientOnly>
</template>
